import React, { useEffect, useState } from 'react'
import { Bracket, Seed, SeedItem, SeedTeam } from 'react-brackets'
import _ from 'lodash'

import './css/print-table.css'
import { Col, Input, Row } from 'antd'

const TableScoreCard = (props) => {
  const [round, setRound] = useState({})

  // eslint-disable-next-line
  useEffect(() => {
    setRound(props.round)
  })

  const cardStyle = {
    border: '1px solid #000',
    margin: '2em'
  }

  if (props.break) {
    cardStyle.pageBreakAfter = 'always'
  }

  return (
    <>
      <Row key={round.id} style={cardStyle}>
        <Col span={24}><span style={{ fontWeight: 'bold', paddingLeft: '.5em' }}>Tournament:</span> {props.config.tournament_name}</Col>
        <Col span={24}><span style={{ fontWeight: 'bold', paddingLeft: '.5em' }}>Match:</span> {round.id}</Col>
        <Col span={24} style={{ border: '1px solid #000' }}>
          <Row>
            <Col span={4} offset={6}>1st Violation</Col>
            <Col span={4}>2nd Violation</Col>
            <Col span={4}>3rd Violation</Col>
            <Col span={4}>4th Violation</Col>
          </Row>
        </Col>
        <Col span={24} style={{ border: '1px solid #000' }}>
          <Row>
            <Col span={5} style={{ paddingLeft: '.5em' }}>Name</Col>
            {_.times(props.config.score, (num) =>
              <Col span={1} style={{ textAlign: 'center', border: '1px solid #000' }}>{num + 1}</Col>
            )}
            <Col span={2} style={{ textAlign: 'center', border: '1px solid #000' }}>Score</Col>
            <Col span={2} style={{ textAlign: 'center', border: '1px solid #000' }}>V/D</Col>
          </Row>
        </Col>
        <Col span={24} style={{ border: '1px solid #000' }}>
          <Row>
            <Col span={5} style={{ textAlign: 'right', paddingRight: '1em' }}>{round?.teams?.[0]?.name}</Col>
            {_.times(props.config.score, (num) =>
              <Col span={1}><Input /></Col>
            )}
            <Col span={2}><Input /></Col>
            <Col span={2}><Input /></Col>
          </Row>
        </Col>
        <Col span={24} style={{ border: '1px solid #000' }}>
          <Row>
            <Col span={5} style={{ textAlign: 'right', paddingRight: '1em' }}>{round?.teams?.[1]?.name}</Col>
            {_.times(props.config.score, (num) =>
              <Col span={1}><Input /></Col>
            )}
            <Col span={2}><Input /></Col>
            <Col span={2}><Input /></Col>
          </Row>
        </Col>
        <Col span={24} style={{ border: '1px solid #000' }}>
          <Row>
            <Col span={4} offset={6}>1st Violation</Col>
            <Col span={4}>2nd Violation</Col>
            <Col span={4}>3rd Violation</Col>
            <Col span={4}>4th Violation</Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row>
            <Col span={12} style={{ border: '1px solid #000', paddingLeft: '1em' }}>Referee:</Col>
            <Col span={12} style={{ border: '1px solid #000', paddingLeft: '1em' }}>Scorekeeper:</Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

const PrintTable = React.forwardRef((props, ref) => {
  const [activeMatches, setActiveMatchs] = useState([])
  const [allMatches, setAllMatches] = useState([])

  useEffect(() => {
    const matches = []
    const everyMatches = []

    props.rounds.forEach((round) => {
      round.seeds.forEach(match => {
        if (match) {
          if (match?.teams?.[0]?.id && match?.teams?.[1]?.id && _.isUndefined(match?.teams?.[0].isWinner)) {
            matches.push({
              id: match.id,
              teams: [match.teams[0], match.teams[1]]
            })
          }
          if (match?.teams?.[0]?.score !== 'BYE' && match?.teams?.[1]?.score !== 'BYE') {
            everyMatches.push({
              id: match?.id,
              teams: [match?.teams?.[0], match?.teams?.[1]]
            })
          }
        }
      })
    })

    setActiveMatchs(matches)
    setAllMatches(everyMatches)
    // eslint-disable-next-line
  }, [props.sheetLayout, props.seeding])

  const CustomSeed = ({ seed, breakpoint, roundIndex, seedIndex }) => {
    return (
      <Seed mobileBreakpoint={breakpoint} style={{ fontSize: 12 }}>
        <SeedItem>
          <div>
            <SeedTeam>{seed?.teams?.[0]?.name || '\u00a0'}</SeedTeam>
            <SeedTeam>{seed?.teams?.[1]?.name || '\u00a0'}</SeedTeam>
            <div className='match-display'>{seed?.id}</div>
          </div>
        </SeedItem>
      </Seed>
    )
  }

  const CustomTitle = (title, roundIndex) => {
    return <div className='round-title'>{title}</div>
  }

  return (
    <div ref={ref} className='print'>
      {props.sheetLayout === 'a'
        ? (
          <>
            <Bracket rounds={props.rounds} renderSeedComponent={CustomSeed} roundTitleComponent={CustomTitle} mobileBreakpoint={0} />
          </>)
        : ''}
      {props.sheetLayout === 'b'
        ? (
          <>
            {activeMatches.map((round, index) =>
              <TableScoreCard config={props.config} key={round.id} round={round} break={(index + 1) % 4 === 0} />
            )}
          </>)
        : ''}
      {props.sheetLayout === 'c'
        ? (
          <>
            {allMatches.map((round, index) =>
              <TableScoreCard config={props.config} key={round.id} round={round} break={(index + 1) % 4 === 0} />
            )}
          </>)
        : ''}
    </div>
  )
})

export default PrintTable
